//      
import {           } from 'css-box-model';
                                                                  
import { offsetRectByPosition } from '../rect';

export default (droppable                    , area      )       => {
  const frame              = droppable.frame;
  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/with-scroll-change/with-droppable-scroll.js